const LOST_REASONS = [
    { value: "timing", label: "Timing" },
    { value: "budget", label: "Budget" },
    { value: "price", label: "Price" },
    { value: "no_need", label: "No Need" },
    { value: "existing_provider", label: "Existing Provider" },
    { value: "wrong_person", label: "Wrong Person" },
    { value: "ghosted", label: "Ghosted" },
    { value: "no_show", label: "No Show" },
    { value: "competitor", label: "Competitor" },
    { value: "not_qualified", label: "Not Qualified" },
    { value: "other", label: "Other" },
];

function getLostReasonLabel(value) {
    const normalized = String(value || "").trim().toLowerCase().replace(/[ -]+/g, "_");
    return LOST_REASONS.find((reason) => reason.value === normalized)?.label || "";
}

export { LOST_REASONS, getLostReasonLabel };